export default __webpack_public_path__ + "locales/si/Files.json?hash=72042201dce2f69165f5e69b87ec6a8b";